<!-- Single root router-outlet: layout chrome toggles via *ngIf/CSS only so nested navigations
     (e.g. dashboard → athletes) never swap between different outlet instances. -->
<ui-navbar *ngIf="useCustomLayout" [company]="company"></ui-navbar>
<app-shop-navbar *ngIf="!useCustomLayout && shopLayout" [company]="company"></app-shop-navbar>

<div [class.layout-wrapper]="useCustomLayout || shopLayout"
     [class.layout-wrapper--full]="fullBleed">
    <div [class.container-xxl]="(useCustomLayout || shopLayout) && !fullBleed"
         [class.py-lg-6]="(useCustomLayout || shopLayout) && !fullBleed"
         [class.h-100]="(shopLayout && !useCustomLayout) || fullBleed"
         [class.layout-full]="fullBleed">
        <router-outlet></router-outlet>
    </div>
</div>

<ui-footer *ngIf="useCustomLayout || shopLayout" [shopLayout]="shopLayout" [company]="company"></ui-footer>

<ngx-spinner *ngIf="useCustomLayout" bdColor="rgba(30, 41, 59, 0.85)" [fullScreen]="true" type="">
    <div class="welldone-loader">
        <div class="loader-logo-container">
            <img src="assets/logo.svg" alt="Well Done Logo" class="loader-logo">
        </div>
        <div class="loader-spinner"></div>
        <p class="loader-text">Caricamento in corso...</p>
    </div>
</ngx-spinner>
